import type React from "react";
import { cn } from "src/shadcn/lib/utils";

import {
  Tabs as ShadcnTabs,
  TabsList as ShadcnTabsList,
  TabsTrigger as ShadcnTabsTrigger,
  TabsContent as ShadcnTabsContent,
} from "src/shadcn/components/tabs";

const Tabs = (props: React.ComponentProps<typeof ShadcnTabs>) => (
  <ShadcnTabs {...props} />
);

const TabsList = (props: React.ComponentProps<typeof ShadcnTabsList>) => (
  <ShadcnTabsList {...props} />
);

const TabsTrigger = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnTabsTrigger>) => (
  <ShadcnTabsTrigger
    className={cn("cursor-pointer disabled:cursor-not-allowed", className)}
    {...props}
  />
);

const TabsContent = (props: React.ComponentProps<typeof ShadcnTabsContent>) => (
  <ShadcnTabsContent {...props} />
);

export { Tabs, TabsList, TabsTrigger, TabsContent };
export { tabsListVariants } from "src/shadcn/components/tabs";
